module.exports = {
  redirectToPro: (lang, extraParameters) => {
    // Go to the german version only if you select German. Otherwise use the English one
    const language = lang && "de" === lang ? lang : "en"
    const extraUrl = extraParameters ? `&${extraParameters}` : ""
    window.location.href = `/pro?lng=${language}${extraUrl}`
  },
  redirectToPartnerUI: () => {
    if (window.location.host === "www.metaloop.com") {
      window.location.href = "https://app.metaloop.com/"
    } else {
      window.location.href = "https://app-qa.metaloop.com/"
    }
  },
  openLinkedin: () => {
    window.open("https://www.linkedin.com/company/metaloop", "_blank")
  },
  openFacebook: () => {
    window.open("https://www.facebook.com/schrott24/", "_blank")
  },
  openTwitter: () => {
    window.open("https://twitter.com/schrott24", "_blank")
  },
  openYoutube: () => {
    window.open(
      "https://www.youtube.com/channel/UCrIvaKJkiu_V8EQMS8yBv2Q",
      "_blank"
    )
  },
  goToBlog: () => {
    window.location.href = "https://blog.metaloop.com/"
  },
  goToCareers: () => {
    window.location.href = "https://careers.metaloop.com/"
  },
  blogHref: "https://blog.metaloop.com/",
  careersHref: "https://careers.metaloop.com/",
  linkedinHref: "https://www.linkedin.com/company/metaloop",
}
